"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Brain, Lock, RefreshCcw } from "lucide-react";
export default function TePassaEsto() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const problems = [{
    icon: Brain,
    title: "Bloqueos mentales",
    description: "Sientes que algo te frena, pero no sabes exactamente qué. Tu mente repite patrones que antes te servían, pero hoy te están limitando."
  }, {
    icon: Lock,
    title: "Estancamiento personal",
    description: "Por más que lo intentas, sientes que sigues en el mismo punto.No es falta de capacidad, es falta de claridad sobre el siguiente paso."
  }, {
    icon: RefreshCcw,
    title: "Autosabotaje",
    description: "Empiezas con ilusión, pero terminas abandonando. Tu voz interna te hace dudar justo cuando estás a punto de avanzar."
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section className="bg-background py-16 px-6">
      <div className="mx-auto max-w-6xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-semibold text-foreground sm:text-4xl">¿Te sientes identificado con esto?</h2>
          <p className="mt-4 text-muted-foreground">Estas son algunas señales de que tu mente te está frenando más de lo que crees</p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {problems.map((problem, i) => {
          const Icon = problem.icon;
          return <div key={i} data-index={i} ref={refs[i]} className="group flex flex-col items-center text-center transition-all duration-[350ms] ease-[cubic-bezier(0.22,1,0.36,1)]" style={{
            opacity: 1,
            transform: "none"
          }}>
                <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-lg bg-primary-light transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] group-hover:bg-primary/10">
                  <Icon className="h-8 w-8 text-primary transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] group-hover:fill-accent group-hover:text-accent" strokeWidth={1.5} />
                </div>
                <h3 className="mb-3 font-display text-xl font-semibold text-foreground">
                  {problem.title}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground">
                  {problem.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}